<section class="static-page">
  <header class="static-header">
    <span class="static-icon" aria-hidden="true"><i class="fa-solid fa-building"></i></span>
    <h1>About orderYaa</h1>
    <p class="static-subtitle">One platform to run your entire business.</p>
  </header>

  <div class="container">
    <div class="static-content">
      <p>
        orderYaa ERP is built by Tech Colleagues to give growing businesses a single system for
        sales, inventory, accounting, procurement, manufacturing, HR, and CRM — instead of
        stitching together spreadsheets and disconnected tools.
      </p>

      <h2>What we're building</h2>
      <p>
        We started with a point-of-sale and ordering system for retail and food businesses, and
        have expanded it into a full ERP: inventory and warehouse management, double-entry
        accounting, procurement and vendor management, manufacturing and production costing, and
        HR — all connected to the same data, in one platform.
      </p>

      <h2>How we work</h2>
      <ul>
        <li>Ship features that solve real problems our customers report, not just what looks good on a slide</li>
        <li>Keep the product simple enough for a small business owner to set up without a consultant</li>
        <li>Support customers directly — our team is reachable, not hidden behind ticket queues</li>
      </ul>

      <h2>Get in touch</h2>
      <p>
        Questions about the company or the product? Reach us at
        <a href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=hr@techcolleagues.com" target="_blank" rel="noopener noreferrer">hr&#64;techcolleagues.com</a>.
      </p>
    </div>
  </div>
</section>
